import config from '@app/config'

// Every real (browser) cookie name carries the runtime `cookiePrefix` (`COOKIE_PREFIX`, hydrated
// to the client via the serialized store config): `st_` on staging, none on prod, so environments
// sharing `.kidsout.ru` don't clash. The backend prefixes its own cookies the same way.
//
// localStorage keys are intentionally not namespaced here: they are origin-scoped
// and never clash across the prod/staging subdomains.

/** A cookie's name in this environment: `createCookieName('kidsout__at')` → `kidsout__at` / `st_kidsout__at`. */
export const createCookieName = (name: string): string => `${config.cookiePrefix}${name}`
